/* ==========================================================================
   whero-loc-card.js — live updates for snippets/whero-loc-card.liquid
   --------------------------------------------------------------------------
   Listens for the whero:status-updated event dispatched by
   whero-status-pill.js and, for every .loc-card on the page:

     - Updates .loc-status state class (open / closing / closed) and label
       text if it changed since server render.
     - Fills .loc-dist with the per-shop Haversine distance once a user
       position is resolved.
     - Reveals .loc-closest-tag on the single closest card (and hides it
       on all others, in case it was previously set).

   No DOM is mutated until the event fires. If the status pill is absent
   from the page, this script silently does nothing.
   ========================================================================== */
(function () {
  'use strict';

  var CARD_SELECTOR = '.loc-card';

  function labelFor(state, variant, closeClock) {
    // Match server-rendered text in snippets/whero-loc-card.liquid.
    if (variant === 'compact') {
      if (state === 'open')    return 'Open · ' + (closeClock || '');
      if (state === 'closing') return 'Closes ' + (closeClock || '');
      return 'Closed';
    }
    if (state === 'open')    return 'Open now · Closes ' + (closeClock || '');
    if (state === 'closing') return 'Closes soon · ' + (closeClock || '');
    return 'Closed';
  }

  function formatClockTime(hhmm) {
    var parts = (hhmm || '').split(':');
    if (parts.length !== 2) return '';
    var h = parseInt(parts[0], 10);
    var m = parts[1];
    if (isNaN(h)) return '';
    var dh, ampm;
    if (h === 0)       { dh = 12; ampm = 'am'; }
    else if (h < 12)   { dh = h;  ampm = 'am'; }
    else if (h === 12) { dh = 12; ampm = 'pm'; }
    else               { dh = h - 12; ampm = 'pm'; }
    return m === '00' ? (dh + ampm) : (dh + ':' + m + ampm);
  }

  function formatDistance(mi) {
    if (typeof mi !== 'number' || isNaN(mi)) return '';
    return (mi < 10 ? mi.toFixed(1) : Math.round(mi)) + ' mi';
  }

  function todayKeyInLA() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      weekday: 'short',
    });
    return fmt.format(new Date()).toLowerCase().slice(0, 3);
  }

  function variantOf(cardEl) {
    return cardEl.classList.contains('loc-card--compact') ? 'compact' : 'default';
  }

  function applyToCard(cardEl, entry, dayKey, isClosest) {
    var variant = variantOf(cardEl);
    var state = entry.state;
    var shop = entry.shop;
    var today = shop.hours && shop.hours[dayKey];
    var closeClock = (today && today.close) ? formatClockTime(today.close) : '';

    // Status pill: swap state class + text content.
    var statusEl = cardEl.querySelector('[data-role="status"]');
    if (statusEl) {
      statusEl.classList.remove('open', 'closing', 'closed');
      statusEl.classList.add(state);
      // Rebuild inner text while preserving the .dot element.
      var dot = statusEl.querySelector('.dot');
      statusEl.textContent = '';
      if (dot) statusEl.appendChild(dot);
      else {
        var d = document.createElement('span');
        d.className = 'dot';
        d.setAttribute('aria-hidden', 'true');
        statusEl.appendChild(d);
      }
      statusEl.appendChild(document.createTextNode(labelFor(state, variant, closeClock)));
    }

    // Distance.
    var distEl = cardEl.querySelector('[data-role="distance"]');
    if (distEl) {
      if (typeof entry.distanceMi === 'number' && !isNaN(entry.distanceMi)) {
        distEl.textContent = formatDistance(entry.distanceMi);
        distEl.removeAttribute('hidden');
      } else {
        distEl.textContent = '';
        distEl.setAttribute('hidden', '');
      }
    }

    // Closest-to-you tag.
    var tagEl = cardEl.querySelector('.loc-closest-tag');
    if (tagEl) {
      if (isClosest) tagEl.removeAttribute('hidden');
      else tagEl.setAttribute('hidden', '');
    }
  }

  function handleStatusUpdated(e) {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    if (cards.length === 0) return;

    var detail = (e && e.detail) || {};
    var ranked = Array.isArray(detail.allShops) ? detail.allShops : [];
    var closestId = detail.closestShop && detail.closestShop.id;
    if (ranked.length === 0) return;

    // Index by shop id for fast lookup.
    var byId = {};
    for (var i = 0; i < ranked.length; i++) {
      var id = ranked[i].shop && ranked[i].shop.id;
      if (id) byId[id] = ranked[i];
    }

    var dayKey = todayKeyInLA();

    for (var j = 0; j < cards.length; j++) {
      var card = cards[j];
      var shopId = card.getAttribute('data-shop');
      var entry = shopId ? byId[shopId] : null;
      if (!entry) continue;
      applyToCard(card, entry, dayKey, shopId === closestId);
    }
  }

  document.addEventListener('whero:status-updated', handleStatusUpdated);
})();
